import { Injectable } from '@angular/core';
import { Cart, MultiCartFacade } from '@spartacus/cart/base/root';
import { UserIdService, WindowRef } from '@spartacus/core';
import { filter, switchMap, take, withLatestFrom } from 'rxjs/operators';
import { getCartIdByUserId } from '../utils/utils';
import { GenActiveCartFacade } from './active-cart.facade';
import { GenMultiCartService } from './multi-cart.service';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { Observable } from 'rxjs';

@Injectable()
export class GenActiveCartService extends ActiveCartService implements GenActiveCartFacade {
  constructor(
    protected genMultiCartService: GenMultiCartService,
    multiCartFacade: MultiCartFacade,
    userIdService: UserIdService,
    winRef: WindowRef,
  ) {
    super(multiCartFacade, userIdService, winRef);
  }

  override addEntry(productCode: string, quantity: number, itemListName?: string, navigatedToPdpFrom?: string, entrySource?: string): void {
    this.requireLoadedCart()
      .pipe(withLatestFrom(this.userIdService.getUserId()))
      .subscribe(([cart, userId]) => {
        this.genMultiCartService.addEntry(
          userId,
          getCartIdByUserId(cart, userId),
          productCode,
          quantity,
          itemListName,
          navigatedToPdpFrom,
          entrySource
        );
      });
  }

  /**
  * Update entry
  *
  * @param entryNumber
  * @param quantity
  * @param pickupStore
  * @param pickupToDelivery
  */
 override updateEntry(
   entryNumber: number,
   quantity?: number,
 ): void {
   this.activeCartId$
     .pipe(withLatestFrom(this.userIdService.getUserId()), take(1))
     .subscribe(([cartId, userId]) => {
       this.genMultiCartService.updateEntry(
         userId,
         cartId,
         entryNumber,
         quantity,
       );
     });
 }

  override getActive(): Observable<Cart> {
    return this.activeCart$;
  }

  override takeActive(): Observable<Cart> {
    return this.isStable().pipe(
      filter((isStable) => isStable),
      switchMap(() => this.getActive()),
      filter((cart) => !!cart),
      take(1)
    )
  }
}
